import { createContext } from 'react';

interface MyContextData {
    refetchBtn:  any,
    setRefetchBtn:any
}
const RefreshContext = createContext<MyContextData | any>(undefined);

export default RefreshContext;
